module.exports = __webpack_public_path__ + "static/media/business-time.d29fb339.svg";